export default function IntroLocation() {
  return (
    <section className="w-full py-20" style={{ backgroundColor: '#f4faf8' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>LOCATION</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">오시는 길 &amp; 연락처</h2>
          <p className="text-sm text-gray-400 mt-3">언제든지 방문하거나 연락 주세요</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 items-stretch">
          {/* Map */}
          <div className="w-full lg:w-3/5 rounded-2xl overflow-hidden" style={{ minHeight: '360px' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.0!2d127.1285!3d35.8562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b5a2b3f3f3f3f%3A0x0!2z7KCV67aA7Iqk7YuV7KeEIOyEse66oA!5e0!3m2!1sko!2skr!4v1680000000000!5m2!1sko!2skr"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '360px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="코리아케어러스 위치"
            ></iframe>
          </div>

          {/* Info */}
          <div className="w-full lg:w-2/5 flex flex-col gap-4">
            {/* Address */}
            <div className="bg-white rounded-2xl p-6 border border-gray-100">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: 'rgba(46,125,107,0.1)' }}>
                  <i className="ri-map-pin-2-line" style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-700 mb-1">본사 주소</p>
                  <p className="text-sm font-medium text-gray-900">전북특별자치도 전주시</p>
                  <p className="text-sm text-gray-600">덕진구 사평로 33, 2층</p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-white rounded-2xl p-6 border border-gray-100">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: 'rgba(46,125,107,0.1)' }}>
                  <i className="ri-phone-line" style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-700 mb-1">대표번호</p>
                  <a href="tel:15668654" className="text-2xl font-bold cursor-pointer hover:opacity-75 transition-opacity" style={{ color: '#2E7D6B' }}>
                    1566-8654
                  </a>
                  <p className="text-xs text-gray-400 mt-1">오전 9시 ~ 오후 11시 · 연중무휴</p>
                </div>
              </div>
            </div>

            {/* Fax & Email */}
            <div className="bg-white rounded-2xl p-6 border border-gray-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: 'rgba(46,125,107,0.1)' }}>
                  <i className="ri-printer-line" style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-700 mb-1">팩스</p>
                  <p className="text-sm font-medium text-gray-900">070-7862-8654</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: 'rgba(46,125,107,0.1)' }}>
                  <i className="ri-mail-line" style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-700 mb-1">이메일</p>
                  <a href="mailto:support@koreacarers.com" className="text-sm font-medium cursor-pointer hover:opacity-75 transition-opacity" style={{ color: '#2E7D6B' }}>
                    support@koreacarers.com
                  </a>
                </div>
              </div>
            </div>

            {/* CTA */}
            <a
              href="tel:15668654"
              className="w-full py-4 rounded-2xl text-sm font-bold text-white text-center whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-phone-line text-base"></i>
              지금 바로 전화 상담하기
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
